<fas-service-dynamic-table class="table-height"
  [columns]="columns"
  [dataMode]="'server'"
  [dataService]="fetchOskStudentsArchivedList"
  [dateFormat]="'dd.MM.yyyy'"
  [columnTemplates]="{
    subscriptionPlanStatusTemp: subscriptionPlanStatusTempRef,
    subscriptionPlanTemp: subscriptionPlanTempRef
  }"
  [showGlobalSearch]="true"
>
  <ng-template #subscriptionPlanTempRef let-row>
    <app-subscription-tag
      [bgColor]="row.oskPlatformSubscriptionPlan.bgColor"
      [fgColor]="row.oskPlatformSubscriptionPlan.fgColor"
      [planName]="row.oskPlatformSubscriptionPlan.planName"
    ></app-subscription-tag>
  </ng-template>
  <ng-template #subscriptionPlanStatusTempRef let-row>
    <div [style.color]="getStatus(row.validTo).color">
      {{ getStatus(row.validTo).status }}
    </div>
  </ng-template>
</fas-service-dynamic-table>
